import StillNotSure from './StillNotSure';
import { connect } from './connect';

export default connect(StillNotSure);
